import React, { useMemo, forwardRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { getEditorViewportHeightCss } from '../../../utils/editorHeight';

/**
 * TinyMCE self-host (GPL) — không dùng Cloud API key / không bị hạn mức load/tháng.
 * Drop-in thay cho <Editor apiKey="..." /> từ @tinymce/tinymce-react.
 */
const DEFAULT_PLUGINS = [
    'advlist', 'anchor', 'autolink', 'charmap', 'code',
    'help', 'image', 'insertdatetime', 'link', 'lists', 'media',
    'preview', 'searchreplace', 'table', 'visualblocks',
];

const DEFAULT_TOOLBAR =
    'undo redo | fontselect | blocks | bold italic backcolor | ' +
    'alignleft aligncenter alignright alignjustify | ' +
    'bullist numlist outdent indent | removeformat | ' +
    'code table help | link | image';

const HtmlEditor = forwardRef(function HtmlEditor(
    {
        value,
        initialValue,
        onInit,
        onEditorChange,
        init = {},
        disabled,
        ...rest
    },
    ref
) {
    // Bỏ apiKey / tinymceScriptSrc nếu caller còn truyền nhầm
    const { apiKey: _ignoredApiKey, tinymceScriptSrc: _ignoredSrc, licenseKey: _ignoredLk, ...safeRest } = rest;

    const mergedInit = useMemo(() => {
        const {
            plugins,
            toolbar,
            height,
            menubar,
            content_style,
            license_key: _lk,
            base_url: _bu,
            suffix: _sf,
            ...callerInit
        } = init || {};

        return {
            height: height ?? getEditorViewportHeightCss(220),
            min_height: 220,
            menubar: menubar !== undefined ? menubar : true,
            plugins: plugins || DEFAULT_PLUGINS,
            toolbar: toolbar || DEFAULT_TOOLBAR,
            branding: false,
            promotion: false,
            content_style:
                content_style ||
                "body { font-family: Helvetica, Arial, 'Times New Roman', Times, serif; font-size: 14px; }",
            ...callerInit,
            // Self-host GPL — luôn ưu tiên, không dùng Cloud
            base_url: '/tinymce',
            suffix: '.min',
            license_key: 'gpl',
        };
    }, [init]);

    return (
        <Editor
            ref={ref}
            value={value}
            initialValue={initialValue}
            onInit={onInit}
            onEditorChange={onEditorChange}
            disabled={disabled}
            {...safeRest}
            tinymceScriptSrc="/tinymce/tinymce.min.js"
            licenseKey="gpl"
            init={mergedInit}
        />
    );
});

export default HtmlEditor;
